import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from "rxjs";
import { Location } from '@angular/common';
import { RewardsService } from '../loyalty-points/rewardservice/rewards.service';
import { CommonService } from '../Services/common.service';
import { AuthService } from '../Services/auth.service';
import { CookieService } from '../Services/cookie'

@Component({
  selector: 'app-loyalty-points-radeem-confirm',
  templateUrl: './loyalty-points-radeem-confirm.component.html',
  standalone:false,
  styleUrls: ['./loyalty-points-radeem-confirm.component.scss']
})
export class LoyaltyPointsRadeemConfirmComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  shukranNo: string;
  GulfnumberDisplay: string;
  shukranNumberDisplay: string;

  constructor(private location: Location, private router:Router,public redeem:RewardsService,private CommonService:CommonService,private auth:AuthService,private cookieService:CookieService ) { }
  selectedRadeemid;
  selectedPoint: number | string = 0;
  Redeemto:string=""
  Amount:string=""
  GulfNumber:string=""
  // Mobile parity (screens #7-8): mandatory acknowledgement checkbox + helpers
  acceptTerms: boolean = false;
  partnerCode: string = '';
  partnerCategory: string = '';
  isGiveBack: boolean = false;
  perPointRate: number = 0;
  pointsEquivalent: number = 0;
  formattedAmount: string = '0';
 async ngOnInit():Promise <void> {
  // Prefer in-memory service data (no cookie refresh needed)
  if (this.redeem.pendingRedemption) {
    const pr = this.redeem.pendingRedemption;
    this.selectedRadeemid = pr.redeemId;
    this.Redeemto = pr.redeemType;
    this.selectedPoint = pr.selectedPoint;
    this.Amount = pr.amount;
    console.log("From service:", this.Redeemto, this.selectedPoint, this.Amount);
  } else {
    // Fallback to cookies
    this.selectedRadeemid=await this.cookieService.get("Redeemid",true);
    this.Redeemto=await this.cookieService.get("RedeemType",true);
    this.selectedPoint=await this.cookieService.get("selectedPoint",true) || 0;
    this.Amount=await this.cookieService.get("Amount",true);
  }

  this.GulfNumber=await this.cookieService.get("Gulfnumber",true);
  this.shukranNo=await this.cookieService.get("shukranNo1",true);

  this.GulfnumberDisplay =await this.cookieService.get("gulfAirFFPnumber", true);
  this.shukranNumberDisplay =await this.cookieService.get("shukranNumber2", true);

  // Read LoyaltyCard from cookie if not set
  let L = JSON.parse(await this.cookieService.get("LoyaltyCard", true));
  if (L && (this.redeem.LoyaltyCard == null || this.redeem.LoyaltyCard == undefined)) {
    this.redeem.LoyaltyCard = L;
  }

  // Compute display data for the green summary card and detail rows.
  await this.deriveDisplayData();
}

/** Derive partnerCode / isGiveBack / pointsEquivalent / formattedAmount from the
 *  pending redemption data so the template can render mobile screens #7-8. */
private async deriveDisplayData(): Promise<void> {
  // partnerCode — prefer in-memory pendingRedemption, fall back to cookie.
  if (this.redeem?.pendingRedemption?.partnerCode) {
    this.partnerCode = this.redeem.pendingRedemption.partnerCode;
  } else {
    this.partnerCode = (await this.cookieService.get("RedeemPartnerCode", true)) || '';
  }
  // partnerCategory — set by the catalog page when the user picked a
  // partner. Used in the "Reward type" detail row on this screen.
  this.partnerCategory = this.redeem?.pendingRedemption?.category || '';
  this.perPointRate = Number(this.redeem?.pendingRedemption?.perPointRate) || 0;
  this.isGiveBack = this.partnerCode === 'RHF' || this.partnerCode === 'ZAKAT';

  // selectedPoint is in points.
  const pts = Number(this.selectedPoint) || 0;
  this.pointsEquivalent = pts;

  // Derive the BHD amount the user is redeeming for the equivalent line.
  // 1) For Give Back (RHF/ZAKAT): 140 pts = 1 BHD.
  // 2) For everything else: use the partner's perPointRate from the API
  //    (e.g. Gulf Air amount=1 → 1000 pts = 1000 miles, Etihad amount=0.77
  //    → 1000 pts = 770 miles, Shukran amount=1.4 → 1000 pts = 1400 Shukrans).
  // 3) Fallback for cashback if perPointRate is missing.
  const perPointRate = Number(this.redeem?.pendingRedemption?.perPointRate) || 0;
  if (this.isGiveBack) {
    this.formattedAmount = (pts / 140).toFixed(3);
  } else if (perPointRate > 0) {
    this.formattedAmount = (pts * perPointRate).toFixed(3);
  } else if (this.partnerCode === 'CASHBACK') {
    this.formattedAmount = (pts * 0.007).toFixed(3);
  } else {
    this.formattedAmount = '';
  }
}

  /** Returns the conversion rate string for the Conversion rate detail row.
   *  e.g. "1 pt = BHD 0.007 donation" for RHF, "1 pt = 1 mile" for Gulf Air. */
  getConfirmRateDisplay(): string {
    if (this.perPointRate <= 0) return '';
    if (this.isGiveBack) {
      return `1 pt = BHD ${this.perPointRate.toFixed(4)} donation`;
    }
    return `1 pt = ${this.perPointRate} ${this.getRateUnit()}`;
  }

  /** Unit label for the conversion rate (e.g. "Miles", "Avios", "Shukrans"). */
  getRateUnit(): string {
    const code = (this.partnerCode || '').toUpperCase();
    if (code === 'GULF_AIR_FFP' || code === 'ETIHAD') return 'Miles';
    if (code === 'VERNOST_QRPRIVILEGECLUB' || code === 'QATAR') return 'Avios';
    if (code === 'SHUKRAN') return 'Shukrans';
    if (code === 'JAWAHER') return 'Jawaher Points';
    if (code === 'CASHBACK') return 'BHD cashback';
    return 'units';
  }

  showModal(num) {
    this.modalObservable.next(num);
  }

  back() {
    this.location.back()
  }

  /** Mobile #8: Cancel returns to the catalog without side effects. */
  cancel(): void {
    console.log('[LoyaltyPointsRadeemConfirm] cancel');
    this.router.navigateByUrl('/LoyaltyPointsRadeem');
  }

  /** Continue button — only proceeds when the user has accepted the condition. */
  canContinue(): boolean {
    return this.acceptTerms === true;
  }
  async Next() {
    // Prefer in-memory service data
    let partnerCode: string = "";
    let accountNumberRequired: boolean = false;
    let redemptionAmountBhd: number = 0;
    if (this.redeem.pendingRedemption) {
      partnerCode = this.redeem.pendingRedemption.partnerCode || "";
      accountNumberRequired = this.redeem.pendingRedemption.accountNumberRequired;
      redemptionAmountBhd = this.redeem.pendingRedemption.redemptionAmountBhd || 0;
    } else {
      partnerCode = await this.cookieService.get("RedeemPartnerCode", true) || "";
      accountNumberRequired = await this.cookieService.get("accountNumberRequired", true) === 'true';
    }

    // Read from cookies directly
    let gulfAirAccountNo = await this.cookieService.get("gulfAirFFPnumber", true) || "";
    let shukranNo = await this.cookieService.get("shukranNumber2", true) || "";
    let manualAccountNumber = await this.cookieService.get("manualAccountNumber", true) || "";
    // Clear manual account number after reading
    await this.cookieService.set("manualAccountNumber", "", true);
    let internalCardId = this.redeem?.LoyaltyCard?.cardInternalId;

    // If LoyaltyCard not set, read from cookie
    if (!internalCardId) {
      let L = JSON.parse(await this.cookieService.get("LoyaltyCard", true));
      if (L) {
        this.redeem.LoyaltyCard = L;
        internalCardId = L.cardInternalId;
      }
    }

    let accountNumber = "";
    // Get account number from partnerAccounts for all partners
    const partnerAccounts: any[] = this.redeem?.LoyaltyCard?.partnerAccounts || [];
    const partnerAccount = partnerAccounts.find((p: any) => p.partnerCode === partnerCode);
    if (partnerAccount?.accountNumber) {
      accountNumber = partnerAccount.accountNumber;
    }
    // For Jawaher, if no accountNumber, use CPR (idno)
    if (!accountNumber && partnerCode === "JAWAHER") {
      accountNumber = this.auth?.RegisteredUser?.idno || "";
    }

    // Give Back (RHF/ZAKAT): send BHD amount alongside points
    const isGiveBack = partnerCode === 'RHF' || partnerCode === 'ZAKAT';
    const selectedPointNum = Number(this.selectedPoint) || 0;
    if (isGiveBack && !redemptionAmountBhd) {
      redemptionAmountBhd = Math.round(selectedPointNum / 140);
    }

    let body: any = {
      internalCardId: internalCardId,
      partnerCode: partnerCode,
      totalPointsForRedemption: selectedPointNum,
      accountNumber: accountNumber,
      gulfAirAccountNo: gulfAirAccountNo,
      shukranNo: shukranNo,
    };
    if (isGiveBack) {
      body.redemptionAmountBhd = redemptionAmountBhd;
    }
    this.CommonService.presentLoading();
    this.redeem.PointsRedemption(this.auth.accessToken,body).then((data:any)=>{

      if(data?.response?.code==1){
        this.CommonService.hideLoading();
        // Store full redemption result + pending data for the success screen BEFORE clearing
        this.redeem.lastRedemptionResult = {
          status: data?.response?.content?.status || '',
          revisedAvailablePoints: data?.response?.content?.revisedAvailablePoints || '',
          transferReference: data?.response?.content?.transferReference || '',
          redeemType: this.redeem.pendingRedemption?.redeemType || this.Redeemto || '',
          selectedPoint: this.redeem.pendingRedemption?.selectedPoint || this.selectedPoint || 0,
          amount: this.redeem.pendingRedemption?.amount || this.Amount || '',
          partnerCode: this.redeem.pendingRedemption?.partnerCode || partnerCode || '',
          category: this.redeem.pendingRedemption?.category || '',
          imageUrl: this.redeem.pendingRedemption?.imageUrl || '',
          perPointRate: this.redeem.pendingRedemption?.perPointRate || 0,
          redemptionAmountBhd: this.redeem.pendingRedemption?.redemptionAmountBhd || 0
        };
        this.redeem.lastRedemptionTransferReference = data?.response?.content?.transferReference || '';
        // Clear the pending redemption after success
        this.redeem.pendingRedemption = null;
        this.router.navigateByUrl('/LoyaltyPointsRadeemSucces');

      }else{
        this.CommonService.hideLoading();
        this.CommonService.ParseErrorAlert('','',this.router,data);

      }


    })

  }


}
